import { createFeatureSelector } from '@ngrx/store';

import { ManageBookingState } from '../../interfaces';
import { MANAGE_BOOKING_FEATURE_KEY } from '../../constants';

export const selectManageBookingState = createFeatureSelector<ManageBookingState>(MANAGE_BOOKING_FEATURE_KEY);
